// extracted by mini-css-extract-plugin
export var deliveryOptions = "styles-mod--delivery-options--278bc";
export var doContent = "styles-mod--do-content--e82f3";
export var frContent = "styles-mod--fr-content--48715";
export var freeReturns = "styles-mod--free-returns--f310f";
export var freeShippingText = "styles-mod--free-shipping-text--132cd";
export var mobileView = "styles-mod--mobile-view--699da";
export var questionMark = "styles-mod--question-mark--9c1f4";
export var shippingEta = "styles-mod--shipping-eta--307fc";
export var tooltip = "styles-mod--tooltip--f531f";
export var tooltipContent = "styles-mod--tooltip-content--889ac";
export var tooltipInfo = "styles-mod--tooltip-info--30824";